import { useState } from "react";
import { items } from "../utils/NavigationItems";
import { isRegistrationOpen } from "../utils/registration";

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const links = items.filter(
    (item) =>
      item.enabled &&
      item.name !== "home" &&
      (item.name !== "register" || isRegistrationOpen())
  );

  return (
    <nav className="hsyc-nav" aria-label="Main">
      <div className="hsyc-wrap hsyc-nav__bar">
        <a href="/" className="hsyc-nav__logo">
          <img src="/camplogo.png" alt="Houston Sikh Youth Camp home" />
        </a>
        <button
          className="hsyc-nav__toggle"
          aria-expanded={isOpen}
          aria-controls="hsyc-nav-links"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? "Close" : "Menu"}
        </button>
        <ul
          id="hsyc-nav-links"
          className={`hsyc-nav__links${isOpen ? " is-open" : ""}`}
        >
          {links.map((item) => (
            <li key={item.id}>
              <a
                href={item.href_field}
                className={
                  item.name === "register" ? "hsyc-nav__register" : undefined
                }
                onClick={() => setIsOpen(false)}
              >
                {item.display_name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
